import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiStepCounterProvider} from "../api-step-counter/api-step-counter";
import {UserStatsProvider} from "../user-stats/user-stats";
import {UserStats} from "../api-course-data/user-state-dto";
import * as moment from "moment";

class AbstractProvider {
  constructor(protected statsProvider: UserStatsProvider) {

  }

  makeSync(date: string): Promise<UserStats> {
    return new Promise<UserStats>((resolve, reject) => {
      reject('Not implemented yet');
    });
  }

  makeDateRangeSync(startDate: string, endDate: string) {
    return new Promise<UserStats>((resolve, reject) => {
      reject('Not implemented yet');
    });
  }

  syncAvailable() {
    return new Promise<boolean>((resolve, reject) => {
      resolve(false);
    });
  }

  isRemote() {
    return false;
  }
}

class AbstractRemoteProvider extends AbstractProvider {
  constructor(protected statsProvider: UserStatsProvider, protected apiStepCounter: ApiStepCounterProvider) {
    super(statsProvider);
  }

  syncAvailable() {
    return new Promise<boolean>((resolve, reject) => {
      resolve(true);
    });
  }

  isRemote() {
    return true;
  }

  makeSync(date: string): Promise<UserStats> {
    var me = this;
    return new Promise((success, error) => {
      me.apiStepCounter.syncSteps(date).then(res => {
        for (var k in res) {
          me.statsProvider.getUserStats(res[k].date).then(stats => {
            stats.steps = res[k].steps;
            stats.mood = res[k].mood;
            success(stats);
          })
        }
        success()
      }).catch(error)
    });
  }

  makeDateRangeSync(startDate: string, endDate: string): Promise<UserStats> {
    var me = this;
    return new Promise((success, error) => {
      me.apiStepCounter.syncRangeSteps(startDate, endDate).then(res => {
        for (var k in res) {
          let dataObject = res[k];
          me.statsProvider.getUserStats(dataObject.date).then(stats => {
            console.log(dataObject, stats);
            stats.steps = dataObject.steps;
            stats.mood = dataObject.mood;
            stats.activitySum = dataObject.activitySum;
            success(stats);
          })
        }
        success()
      }).catch(error)
    });
  }
}

export class LocalProvider extends AbstractProvider {
}

export class GoogleProvider extends AbstractRemoteProvider {
}

export class FitbitProvider extends AbstractRemoteProvider {
}

export class HealthkitProvider extends AbstractProvider {
  syncAvailable() {
    return new Promise<boolean>((resolve, reject) => {
      if ((window as any).plugins && (window as any).plugins.healthkit) {
        (window as any).plugins.healthkit.checkAuthStatus(
          {
            'type': 'HKQuantityTypeIdentifierStepCount'
          },
          (status: string) => {
            if (status == 'authorized') {
              return resolve(true);
            }

            (window as any).plugins.healthkit.requestAuthorization({readTypes: ['HKQuantityTypeIdentifierStepCount']}, function (status) {
              resolve(true)
            }, err => {
              resolve(false)
            });
          },
          error => {
            resolve(false);
          }
        );
      }
    })
  }

  makeSync(date: string): Promise<UserStats> {
    return this.makeDateRangeSync(date, date);
  }

  makeDateRangeSync(startDate: string, endDate: string): Promise<UserStats> {
    var me = this;


    return new Promise((success, error) => {
      var inDate = new Date(startDate);
      inDate.setHours(0);
      inDate.setMinutes(0);
      inDate.setSeconds(0);
      var endDateObject = new Date(endDate);
      endDateObject.setHours(25);
      endDateObject.setMinutes(59);
      endDateObject.setSeconds(59);

      (window as any).plugins.healthkit.querySampleTypeAggregated({
          "startDate": inDate,
          "endDate": endDateObject,
          "aggregation": "day",
          "sampleType": "HKQuantityTypeIdentifierStepCount",
          "unit": "count"
        },
        function (value) {
          var data = {};
          for (var k in value) {
            var elem = value[k];
            var startDate = elem.startDate.split('T')[0];
            if (!startDate) {
              continue;
            }

            if (!data[startDate]) {
              data[startDate] = 0;
            }

            data[startDate] += elem['quantity'];
          }

          for (var k in data) {
            me.statsProvider.getUserStats(k).then(stats => {
              stats.steps = parseInt(data[stats.date]);
              me.statsProvider.updateData(stats);
              success(stats);
            })
          }

        },
        function (error) {
          console.log(error);
          error(error);
        }
      );
    });
  }
}


export class SHealthProvider extends AbstractProvider {
  syncAvailable() {
    return new Promise<boolean>((resolve, reject) => {
      console.log('shealth init');
      if ((window as any).shealth) {
        var shealth = (window as any).shealth;
        console.log('shealth object', shealth);
        shealth.initialize(() => {
          console.log('shealth initialized');
          shealth.connect(() => {
            console.log('shealth connected');

            shealth.requestPermissions(
              (status: string) => {
                console.log('shealth permission requested', status);
                if (status == 'OK') {
                  return resolve(true);
                }
                resolve(false);
              },
              error => {
                resolve(false);
              }
            )
          }, () => {
            resolve(false)
          })
        }, () => {
          resolve(false)
        });

      } else {
        resolve(false);
      }
    })
  }

  makeDateRangeSync(startDate: string, endDate: string): Promise<UserStats> {
    return new Promise((success, error) => {

      var startDateMoment = moment(startDate);
      var endDateMoment = moment(endDate);

      while (startDateMoment < endDateMoment) {
        this.makeSync(startDateMoment.format('YYYY-MM-DD')).then(stats => {
          success(stats);
        })

        startDateMoment.add(1, 'd');
      }
    });
  }

  makeSync(date: string): Promise<UserStats> {
    var me = this;
    return new Promise((success, error) => {
      me.syncAvailable().then(() => {
        var shealth = (window as any).shealth;
        shealth.readDateSteps(date, (steps) => {
          me.statsProvider.getUserStats(date).then(stats => {
            stats.steps = steps;
            me.statsProvider.updateData(stats);
            success(stats);
          })
        }, (err) => {
          console.log('shealth error', err)
          error(err);
        }, date);
      }).catch(error);
    });
  }

}

export class HuaweiHealthProvider extends AbstractProvider {
  syncAvailable() {
    return new Promise<boolean>((resolve, reject) => {
      console.log('huawei_health init');
      if ((window as any).huawei_health) {
        var hhealth = (window as any).huawei_health;
        console.log('huawei_health object', hhealth);
        hhealth.initialize(() => {
          console.log('huawei_health initialized');
          hhealth.connect(() => {
            console.log('huawei_health connected');

            hhealth.requestPermissions(
              (status: string) => {
                console.log('hhealth permission requested', status);
                if (status == 'OK') {
                  return resolve(true);
                }
                resolve(false);
              },
              error => {
                resolve(false);
              }
            )
          }, () => {
            resolve(false)
          })
        }, () => {
          resolve(false)
        });

      } else {
        resolve(false);
      }
    })
  }

  makeDateRangeSync(startDate: string, endDate: string): Promise<UserStats> {
    return new Promise((success, error) => {

      var startDateMoment = moment(startDate);
      var endDateMoment = moment(endDate);

      console.log(startDateMoment, endDateMoment);

      while (startDateMoment < endDateMoment) {
        this.makeSync(startDateMoment.format('YYYY-MM-DD')).then(stats => {
          success(stats);
        })

        startDateMoment.add(1, 'd');
      }
    });
  }

  makeSync(date: string): Promise<UserStats> {
    var me = this;
    return new Promise((success, error) => {
      me.syncAvailable().then(() => {
        console.log('HUAWEI HEALTH: make sync start');
        var hhealth = (window as any).huawei_health;
        hhealth.readCustomDateSteps(date, (steps) => {
          console.log('HUAWEI HEALTH: read custom steps', date, steps);
          me.statsProvider.getUserStats(date).then(stats => {
            stats.steps = steps;
            me.statsProvider.updateData(stats);
            success(stats);
          })
        }, (err) => {
          console.log('hhealth error', err)
          error(err);
        });
      }).catch(error);
    });
  }

}

/*
  Generated class for the StepCounterEngineProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class StepCounterEngineProvider {

  engines: Map<string, AbstractProvider>;

  constructor(private apiStepCounter: ApiStepCounterProvider, private statsProvider: UserStatsProvider) {
    this.engines = new Map<string, AbstractProvider>();
    this.engines.set('google', new GoogleProvider(statsProvider, apiStepCounter));
    this.engines.set('fitbit', new FitbitProvider(statsProvider, apiStepCounter));
    this.engines.set('healthkit', new HealthkitProvider(statsProvider));
    this.engines.set('manual', new LocalProvider(statsProvider));
    this.engines.set('shealth', new SHealthProvider(statsProvider));
    this.engines.set('huawei', new HuaweiHealthProvider(statsProvider));
    this.engines.set('', new LocalProvider(statsProvider));
  }


  getEngine(type: string) {
    return this.engines.get(type);
  }

}



// WEBPACK FOOTER //
// ./src/providers/step-counter-engine/step-counter-engine.ts